import { FormBuilder, FormGroup } from '@angular/forms';
import {
  FormConfig,
  IFormConfig,
} from '../eo-base-form-control/eo-base-form-control.model';

export interface IEoFormPanelConfig extends IFormConfig {
  header?: string;
  name: string;
  styleClass?: string;
  panelContentStyleClass?: string;
  headerIcon?: string;
  headerStyleClass?: string;
}

export class EoFormPanelConfig
  extends FormConfig
  implements IEoFormPanelConfig
{
  header?: string;
  name: string;
  styleClass?: string;
  panelContentStyleClass?: string;
  headerIcon?: string;
  headerStyleClass?: string;

  public static getFormFromConfig(
    configs: EoFormPanelConfig[],
    fB: FormBuilder
  ) {
    return fB.group(
      configs.reduce((acc: any, curr) => {
        acc[curr.name] = fB.group(curr.getFormGroup());
        return acc;
      }, {})
    );
  }

  public static getFormData(form: FormGroup) {
    let formData: any = {};
    Object.keys(form.controls).forEach((key) => {
      let panels = (form.controls[key] as FormGroup).controls;
      formData[key] = {};
      Object.keys(panels).forEach((panel) => {
        formData[key][panel] = panels[panel]?.value;
      });
    });

    return formData;
  }

  public getFormGroupFromForm(form: FormGroup) {
    if (form?.get(this.name)) return form?.get(this.name)! as FormGroup;
    return form;
  }

  // public getFormGroup(fb: FormBuilder){
  //   return fb.group(this.getPanelFormGroup());
  // }

  constructor(obj: IEoFormPanelConfig);
  constructor(obj?: IEoFormPanelConfig) {
    super(obj as IFormConfig);
    this.header = obj?.header;
    this.name = obj?.name ?? '';
    this.styleClass = obj?.styleClass;
    this.panelContentStyleClass = obj?.panelContentStyleClass;
    this.headerIcon = obj?.headerIcon;
    this.headerStyleClass = obj?.headerStyleClass;
  }
}
